import { ScrollReveal } from './ScrollReveal';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { useLang } from '@/lib/translations';

export default function FAQ() {
  const { t } = useLang();
  const f = t.faq;
  return (
    <section className="relative py-24 sm:py-32" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-12">
            <div className="overline mb-4">{f.overline}</div>
            <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-aurocle-text">{f.title}</h2>
          </div>
        </ScrollReveal>
        <ScrollReveal delay={100}>
          <Accordion type="single" collapsible className="space-y-2">
            {f.items.map((faq, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border border-white/6 bg-aurocle-surface px-6 data-[state=open]:border-aurocle-gold/15" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-sm font-heading text-aurocle-text hover:text-aurocle-gold py-5 hover:no-underline">{faq.q}</AccordionTrigger>
                <AccordionContent className="text-sm text-aurocle-platinum-muted leading-relaxed pb-5">{faq.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </ScrollReveal>
      </div>
    </section>
  );
}
